var $ = require('jquery');
var NotificationBase = require('../NotificationBase');
var l10n = require('diy/util/l10n');

var SectionsWelcomeNotification = NotificationBase.extend({
    /**
     * Default sticky for CongratsNotification
     */
    stickyDefault: 0,
    /**
     * Default severity for CongratsNotification
     */
    severityDefault: 3,
    /**
     * Default category for CongratsNotification
     */
    categoryDefault: 2,
    /**
     * parameters for determining default operation,
     * if null or false, they are ignored
     */
    iconCls: 'ui-icon-star',
    /**
     * this method must be implemented by all Notifications
     */
    getContent: function() {
        var title = l10n.getString('section.welcomeNotification.title');
        var linkText = l10n.getString('section.welcomeNotification.linkText');

        var elementHtml =
            '<div class="title">' + title + '</div>' +
            '<a href="javascript:;">' + linkText + '</a>';

        return elementHtml;
    },

    globalAction: function() {
        $('#cc-sa-item-sections').click();
    },

    getName: function() {
        return 'SectionsWelcomeNotification';
    }
});

module.exports = SectionsWelcomeNotification;


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/SectionsWelcomeNotification.js
 ** module id = 664
 ** module chunks = 0
 **/